import { useMemo } from "react";

export interface BoardCreationWizardText {
  titleText: string;
  saveAndExitText: string;
  continueText: string;
  finishText: string;
  backText: string;
  step1LabelText: string;
  step2LabelText: string;
  step3LabelText: string;
  loadingText: string;
}

const readText = (t: (key: string) => string, key: string): string => t(key);

export const useBoardCreationWizardText = (
  t: (key: string) => string,
): BoardCreationWizardText =>
  useMemo(
    () => ({
      titleText: readText(t, "wizard.title"),
      saveAndExitText: readText(t, "wizard.saveAndExit"),
      continueText: readText(t, "wizard.continue"),
      finishText: readText(t, "wizard.finish"),
      backText: readText(t, "wizard.back"),
      step1LabelText: readText(t, "wizard.step1Label"),
      step2LabelText: readText(t, "wizard.step2Label"),
      step3LabelText: readText(t, "wizard.step3Label"),
      loadingText: readText(t, "wizard.loading"),
    }),
    [t],
  );
